import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import React, { useMemo } from 'react'

import { usePPLContext } from '../../PPLProvider'
import { NonMSPropertyType } from '../nonMSTypes'
import NonMSPropertySectionViewMode from './NonMSPropertySectionViewMode'

export const NonMSContainerViewMode = () => {
    const {
        msProperties: { selectedOptions },
        nonMSProperties: { properties },
    } = usePPLContext()

    const nonMSProperties: Array<NonMSPropertyType> = useMemo(() => {
        const nonMSProps =
            properties
                ?.map((prop: NonMSPropertyType) => {
                    return {
                        ...prop,
                        subProperties: prop.subProperties?.filter((props) =>
                            (props.optionGroups ?? []).map((optGrp) =>
                                optGrp.options?.some(
                                    (option) => !!option.isPremiumPlus
                                )
                            )
                        ),
                    }
                })
                .filter(
                    (prop: NonMSPropertyType) => prop.subProperties?.length > 0
                ) ?? []
        return nonMSProps
    }, [properties])

    return (
        <GridItem xs={12}>
            <GridContainer data-testid="nonMSContainerViewMode">
                {nonMSProperties.map((prop: NonMSPropertyType) => {
                    return (
                        <NonMSPropertySectionViewMode
                            key={prop.dummyPropertyId}
                            property={prop}
                            selectedOptions={selectedOptions}
                        />
                    )
                })}
            </GridContainer>
        </GridItem>
    )
}

export default NonMSContainerViewMode
